import { Stack, Text, Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/referrals/study-support')({ component: Page })
function Page() { return <Stack p="lg"><Title order={2}>Study Support referrals</Title><Text c="dimmed">Study Support referral options will appear here.</Text></Stack> }
